import React from 'react'
import { inject, observer } from 'mobx-react'
import { withProps, compose } from 'recompose'
import formPropTypes from './formPropTypes'
import Location from './Filters/Location'
import Price from './Filters/Price'
import PropertyDetails from './Filters/PropertyDetails'
import Features from './Filters/Features'
import Amenities from './Filters/Amenities'

const enhance = compose(
  inject('store'),
  withProps(({ store }) => ({
    uiStateStore: store.uiStateStore,
    valueStateStore: store.valueStateStore
  })),
  observer
)

const SaleForm = ({ uiStateStore, valueStateStore, tabConfig }) => {
  return (
    <div className='ListingForm' role='tabpanel' id={tabConfig.panelId} aria-labelledby={tabConfig.tabId}>
      <div className='ListingForm-group'>
        <Location valueStateStore={valueStateStore} />
        <div className='tablet-viewport zindex-minimal'>
          <Price valueStateStore={valueStateStore} uiStateStore={uiStateStore} view='tablet' />
        </div>
        <PropertyDetails valueStateStore={valueStateStore} uiStateStore={uiStateStore} />
      </div>
      <div className='ListingForm-group'>
        <div className='desktop-viewport'>
          <Price valueStateStore={valueStateStore} uiStateStore={uiStateStore} view='desktop' />
        </div>
        <Features uiStateStore={uiStateStore} valueStateStore={valueStateStore}>
          <Amenities valueStateStore={valueStateStore} />
        </Features>
      </div>
    </div>
  )
}

SaleForm.propTypes = {
  ...formPropTypes
}

export default enhance(SaleForm)
